import type {
  GroupedTableRow,
  GroupingTableRow,
  TableCellObject,
  TableCellValue,
} from './types'

export function isObjectWithLink(
  value: TableCellValue
): value is TableCellObject {
  return (
    typeof value === 'object' &&
    value !== null &&
    'documentLink' in value &&
    typeof value.documentLink === 'string' &&
    value.documentLink.length > 0
  )
}

export function isTableRowGroup(
  row: GroupingTableRow | GroupedTableRow
): row is GroupingTableRow {
  return 'group' in row && typeof row.group === 'string'
}
